import TokenService from "./token.service";
import AuthService from "./auth.service";

const setup = (axiosInstance) => {
  // REQUEST INTERCEPTOR
  axiosInstance.interceptors.request.use(
    (config) => {
      // Önce yeni format (direkt accessToken), sonra eski format
      const token = localStorage.getItem('accessToken') || TokenService.getLocalAccessToken();
      if (token) {
        config.headers["Authorization"] = 'Bearer ' + token;
      }

      // Seçili restoran ID'sini header'a ekle
      const restaurantId = localStorage.getItem('restaurantId');
      if (restaurantId) {
        config.headers["X-Restaurant-Id"] = restaurantId;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // RESPONSE INTERCEPTOR
  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;

      // Hata loglama (Sadece 401 harici veya önemli durumlarda)
      if (err.response && err.response.status !== 401) {
        console.warn(`API Error (${err.response.status}):`, originalConfig?.url);
      }

      // Access Token was expired
      if (
        originalConfig.url !== "/auth/signin" &&
        !originalConfig.url?.includes("/Auth/RefreshToken") && // Refresh token isteğini hariç tut
        !originalConfig.url?.includes("/Management/login") && // Login isteğini hariç tut
        !originalConfig.url?.includes("/Admin/login") && // Admin login'i hariç tut
        err.response &&
        err.response.status === 401 &&
        !originalConfig._retry
      ) {
        originalConfig._retry = true;

        try {

          // localStorage'dan refresh token'ı al
          const refreshToken = localStorage.getItem('refreshToken') || TokenService.getLocalRefreshToken();

          if (!refreshToken) {
            // Yönlendirme YAPMA - sadece hata döndür
            return Promise.reject(new Error("No refresh token available"));
          }

          // Doğrudan AuthService'i kullan
          const response = await AuthService.refreshToken(refreshToken) as any;

          // Yeni token'ı al - backend farklı formatlar dönebilir
          // Format 1: { accessToken: "string", refreshToken: "string" }
          // Format 2: { accessToken: { token: "string" }, refreshToken: { token: "string" } }
          let newAccessToken = response.accessToken;
          let newRefreshToken = response.refreshToken;

          // Eğer accessToken bir object ise, içindeki token'ı al
          if (newAccessToken && typeof newAccessToken === 'object') {
            newAccessToken = newAccessToken.token;
          }

          // Eğer refreshToken bir object ise, içindeki token'ı al
          if (newRefreshToken && typeof newRefreshToken === 'object') {
            newRefreshToken = newRefreshToken.token;
          }

          // Hala bulamadıysak data içinde ara
          if (!newAccessToken) {
            newAccessToken = response.data?.accessToken;
            if (newAccessToken && typeof newAccessToken === 'object') {
              newAccessToken = newAccessToken.token;
            }
          }

          if (!newAccessToken) {
            // Yönlendirme YAPMA
            return Promise.reject(new Error("No access token in refresh response"));
          }

          // localStorage'ı güncelle
          localStorage.setItem('accessToken', newAccessToken);
          if (newRefreshToken) {
            localStorage.setItem('refreshToken', newRefreshToken);
          }

          // TokenService'i de güncelle (backward compatibility)
          TokenService.updateLocalTokens({
            accessToken: newAccessToken,
            refreshToken: newRefreshToken || refreshToken
          });

          // Yeni bir config objesi oluştur - axios bazen originalConfig üzerindeki değişiklikleri görmezden gelebiliyor
          const retryConfig = {
            ...originalConfig,
            headers: {
              ...originalConfig.headers,
              Authorization: "Bearer " + newAccessToken
            },
            // _retry flag'ini koru ki sonsuz döngüye girmesin
            _retry: true
          };

          return axiosInstance(retryConfig);
        } catch (_error: any) {
          // Yönlendirme YAPMA - sadece hatayı reject et
          // Kullanıcı manuel olarak tekrar giriş yapabilir
          return Promise.reject(_error);
        }
      }

      return Promise.reject(err);
    }
  );
};

export default setup;

